/* Install as assets/zaytouna-account-v8.js and load once before </body> with defer. */
(() => {
  if (window.__zaytounaAccountV8) return;
  window.__zaytounaAccountV8 = true;
  const ar = document.documentElement.lang.toLowerCase().startsWith('ar');
  const root = document.querySelector('[data-zcx-dashboard]');
  if (!root) return;
  const editor = root.querySelector('[data-zcx-profile-editor]');
  const save = editor?.querySelector('[data-zcx-save-profile]');
  const status = editor?.querySelector('[data-zcx-profile-status]');
  const names = {firstName:'first', lastName:'last', phone:'phone', country:'country', birthday:'birthday', whatsapp:'whatsapp', telegram:'telegram'};
  let loaded = false, busy = false, previousFocus, previousOverflow;
  const style = document.createElement('style');
  style.textContent = `
    .zcx-profile-editor{inset:auto!important;top:var(--zcx-top,0px)!important;left:0!important;width:100%!important;height:var(--zcx-height,100dvh)!important;padding:10px!important;box-sizing:border-box!important;z-index:2147483000!important}
    .zcx-profile-editor__panel{display:flex!important;flex-direction:column!important;width:min(760px,100%)!important;max-height:100%!important;overflow:hidden!important;box-sizing:border-box!important;padding:16px!important}
    .zcx-profile-editor__head,.zcx-profile-editor__foot{flex-shrink:0!important}
    .zcx-profile-editor__grid{min-height:0!important;overflow:auto!important;overscroll-behavior:contain;padding:4px!important;grid-template-columns:repeat(2,minmax(0,1fr))!important}
    .zcx-profile-editor__grid label{min-width:0!important}.zcx-profile-editor__grid input{min-width:0!important;max-width:100%!important;box-sizing:border-box!important;font-size:16px!important}
    .zcx-profile-editor__foot{background:#fffdf8!important;margin-top:10px!important;padding-bottom:env(safe-area-inset-bottom)!important}
    [data-zcx-profile-status]{overflow-wrap:anywhere;max-height:70px;overflow:auto}
    [data-zcx-save-profile]{min-height:44px!important}.zcx-copy-v8{min-height:44px;border:1px solid #d9cfbb;border-radius:9px;background:#fffdf8;color:#3f481c;padding:8px 12px;cursor:pointer}
    @media(max-width:700px){.zcx-profile-editor__grid{grid-template-columns:minmax(0,1fr)!important}.zcx-profile-editor__foot>div{width:100%!important}.zcx-profile-editor__shopify{font-size:12px!important}.zcx-profile-editor__panel{border-radius:18px!important}}
  `;
  document.head.appendChild(style);
  function resize() {
    const view=window.visualViewport;
    document.documentElement.style.setProperty('--zcx-height',(view?.height||innerHeight)+'px');
    document.documentElement.style.setProperty('--zcx-top',(view?.offsetTop||0)+'px');
  }
  window.visualViewport?.addEventListener('resize',resize);
  window.visualViewport?.addEventListener('scroll',resize);resize();
  async function api(method='GET',body) {
    const response=await fetch('/apps/zaytouna-rewards/profile',{method,credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    let data;
    try {data=await response.json();}catch {throw new Error(ar?'الخادم لم يُرجع بيانات صحيحة. تحقق من App Proxy وتسجيل الدخول.':'Invalid server response. Check App Proxy and sign-in.');}
    if(!response.ok || data.ok===false)throw new Error(data.error||('HTTP '+response.status));
    return data;
  }
  function message(text) {if(status){status.textContent=text;status.setAttribute('role','status');}}
  function close() {
    if(busy)return;
    editor.hidden=true;document.documentElement.style.overflow=previousOverflow||'';previousFocus?.focus();
  }
  async function open() {
    previousFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
    document.body.appendChild(editor); // Escape transformed theme ancestors that clip fixed-position dialogs.
    editor.hidden=false;editor.setAttribute('role','dialog');editor.setAttribute('aria-modal','true');
    document.documentElement.style.overflow='hidden';loaded=false;save.disabled=true;
    message(ar?'جارٍ تحميل البيانات…':'Loading…');
    try {
      const data=await api();const p=data.profile||{};
      for(const [key,selector] of Object.entries(names)){const field=editor.querySelector('[data-zcx-profile-'+selector+']');if(field)field.value=p[key]||'';}
      loaded=true;save.disabled=false;message('');editor.querySelector('input:not([readonly])')?.focus();
    }catch(error){message((ar?'تعذر تحميل البيانات: ':'Unable to load: ')+error.message);}
  }
  async function submit() {
    if(!loaded||busy)return;
    const payload={};
    for(const [key,selector] of Object.entries(names)){
      const field=editor.querySelector('[data-zcx-profile-'+selector+']');
      if(field){if(!field.reportValidity())return;payload[key]=field.value.trim();}
    }
    busy=true;save.disabled=true;message(ar?'جارٍ الحفظ…':'Saving…');
    try {
      await api('POST',payload);
      const data=await api();
      for(const [key,selector] of Object.entries(names))root.querySelectorAll('[data-zcx-view-'+selector+']').forEach(el=>el.textContent=data.profile?.[key]||'—');
      message(ar?'تم الحفظ والتحقق من بياناتك.':'Saved and verified.');
      document.dispatchEvent(new CustomEvent('zaytouna:profile-updated',{detail:data.profile}));
    }catch(error){message((ar?'تعذر إكمال الحفظ: ':'Save could not be completed: ')+error.message);}
    finally{busy=false;save.disabled=false;}
  }
  if(editor&&save){
    document.addEventListener('click',event=>{
      const target=event.target.closest('[data-zcx-edit-profile],[data-zcx-close-profile],[data-zcx-save-profile]');
      if(!target || !(root.contains(target)||editor.contains(target)))return;
      event.preventDefault();event.stopImmediatePropagation();
      if(target.matches('[data-zcx-edit-profile]'))open();
      else if(target.matches('[data-zcx-save-profile]'))submit();
      else close();
    },true);
    editor.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();close();}
      if(event.key==='Tab'){
        const fields=[...editor.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select,textarea')].filter(x=>x.offsetParent!==null);
        const first=fields[0],last=fields[fields.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });
  }
  function copyButtons(){
    root.querySelectorAll('.zcx-live-coupon').forEach(row=>{
      if(row.querySelector('.zcx-copy-v8'))return;
      const code=row.querySelector('strong')?.textContent?.trim();if(!code)return;
      const button=document.createElement('button');button.type='button';button.className='zcx-copy-v8';button.textContent=ar?'نسخ الكود':'Copy code';
      button.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(code);button.textContent=ar?'تم النسخ ✓':'Copied ✓';}catch{button.textContent=ar?'حدد الكود لنسخه':'Select code to copy';}});
      row.appendChild(button);
    });
  }
  copyButtons();new MutationObserver(copyButtons).observe(root,{childList:true,subtree:true});
})();